import { useEffect, useRef, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Card } from "primereact/card";
import { getnetEstadoRequest } from "../../../services/backend/paymentService";
import { sanitizeToken } from "../../../utils/validation";
import { StorageKeys, session } from "../../../utils/storage";
import logger from "../../../shared/utils/logger";

const POLL_INTERVAL_MS = 5000;
const MAX_ATTEMPTS = 8;

const CheckoutProcessing = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const attemptsRef = useRef(0);
  const intervalRef = useRef(null);
  const [error, setError] = useState("");

  useEffect(() => {
    const key =
      sanitizeToken(searchParams.get("key")) ||
      sanitizeToken(session.get(StorageKeys.GETNET_KEY));
    const pedido =
      sanitizeToken(searchParams.get("pedido")) ||
      sanitizeToken(session.get(StorageKeys.GETNET_PEDIDO));

    if (!key || !pedido) {
      setError("Faltan parámetros de transacción.");
      return;
    }

    const cleanup = () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
        intervalRef.current = null;
      }
      session.remove(StorageKeys.GETNET_KEY);
      session.remove(StorageKeys.GETNET_PEDIDO);
    };

    const poll = async () => {
      try {
        const response = await getnetEstadoRequest({ key, pedido });
        const status = String(response?.status || "").toUpperCase();

        if (status === "AUTHORIZED") {
          cleanup();
          navigate("/checkout/exito", {
            replace: true,
            state: { commitFields: response },
          });
          return;
        }

        if (status && status !== "PENDING" && status !== "WAITING") {
          cleanup();
          navigate("/checkout/rechazado", {
            replace: true,
            state: { commitFields: response },
          });
          return;
        }
      } catch (error) {
        logger.error("Error en polling de estado de pago.", error);
      }

      attemptsRef.current += 1;
      if (attemptsRef.current >= MAX_ATTEMPTS) {
        cleanup();
        setError(
          "No se pudo confirmar el estado del pago. Intenta consultar desde 'Mi cuenta'."
        );
      }
    };

    intervalRef.current = setInterval(poll, POLL_INTERVAL_MS);
    poll();

    return cleanup;
  }, [navigate, searchParams]);

  return (
    <div className="getnet-status-shell">
      <Card className="getnet-status-card">
        <div className="getnet-status-icon default">
          <i className="pi pi-spin pi-spinner"></i>
        </div>
        <span className="getnet-chip">Validando pago</span>
        <h2>Estamos confirmando tu transacción</h2>
        <p>No cierres esta ventana. Esto puede tardar unos segundos.</p>
        {error ? <small className="getnet-error-message">{error}</small> : null}
      </Card>
    </div>
  );
};

export default CheckoutProcessing;
